// Account-timezone aware date formatting. Backend/Channex timestamps are UTC;
// some arrive without an offset ("2026-10-12T07:00:00") and must be read as UTC.
let APP_TZ = "Europe/Zagreb";

export function setAppTimezone(tz) {
  if (!tz) return;
  try { new Intl.DateTimeFormat("hr-HR", { timeZone: tz }); APP_TZ = tz; } catch { /* invalid tz → keep */ }
}

export function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  const s = String(value);
  const naive = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(s);
  const d = new Date(naive ? `${s}Z` : s);
  return isNaN(d.getTime()) ? null : d;
}

const fmt = (value, opts) => {
  const d = toDate(value);
  return d ? d.toLocaleString("hr-HR", { timeZone: APP_TZ, ...opts }) : "";
};

export const fmtTime = (v) => fmt(v, { hour: "2-digit", minute: "2-digit" });
export const fmtTimeSec = (v) => fmt(v, { hour: "2-digit", minute: "2-digit", second: "2-digit" });
export const fmtDateShort = (v) => fmt(v, { day: "2-digit", month: "2-digit" });
export const fmtDateLong = (v) => fmt(v, { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
export const fmtDateTime = (v) => fmt(v, { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
export const fmtDateTimeSec = (v) => fmt(v, { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
